"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_types_1 = require("@hotelplan/graphql.types");
const mapFlightClass = {
    [graphql_types_1.FlightClass.Economy]: {
        label: 'common:flightClass.economy',
    },
    [graphql_types_1.FlightClass.PremiumEconomy]: {
        label: 'common:flightClass.premiumEconomy',
    },
    [graphql_types_1.FlightClass.Business]: {
        label: 'common:flightClass.business',
    },
    [graphql_types_1.FlightClass.First]: {
        label: 'common:flightClass.first',
    },
};
exports.default = mapFlightClass;
//# sourceMappingURL=mapFlightClass.js.map